import Entity from '../entity'

export default class Group extends Entity<number>{
    name: string;
    reduction: number;
    active: boolean;
}


